import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { DatePickerModule } from 'primeng/datepicker';
import { DividerModule } from 'primeng/divider';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputRestrictDirective } from 'src/app/directives/input-restrict/input-restrict';
import { NumberFormatDirective } from 'src/app/directives/number-format/number-format';
import { TranslationPipe } from 'src/app/pipes/translation/translation-pipe';
import { AutoError } from '../auto-error/auto-error';
import { AppButton } from '../button/app-button';
import { AppTable } from '../table/app-table';
import { AppTableEditV2 } from '../table/app-table-edit-v2/app-table-edit-v2';
import { TrimInputDirective } from 'src/app/directives/input-trim/input-trim';
import { SelectDefaultsDirective } from 'src/app/directives/selection-default/selection-default';
import { CheckboxModule } from 'primeng/checkbox';
import { NumbersOnly } from 'src/app/directives/numbers-only/numbers-only';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    InputTextModule,
    DividerModule,
    AppButton,
    ToggleSwitchModule,
    InputGroupModule,
    InputGroupAddonModule,
    AppTable,
    AppTableEditV2,
    TextareaModule,
    MessageModule,
    DatePickerModule,
    MultiSelectModule,
    TranslationPipe,
    CardModule,
    RadioButtonModule,
    CheckboxModule,
    AutoError,
    InputNumberModule,
    InputRestrictDirective,
    NumberFormatDirective,
    TrimInputDirective,
    SelectDefaultsDirective,
    NumbersOnly
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    InputTextModule,
    DividerModule,
    AppButton,
    ToggleSwitchModule,
    InputGroupModule,
    InputGroupAddonModule,
    AppTable,
    AppTableEditV2,
    TextareaModule,
    MessageModule,
    DatePickerModule,
    MultiSelectModule,
    TranslationPipe,
    CardModule,
    RadioButtonModule,
    CheckboxModule,
    AutoError,
    InputNumberModule,
    InputRestrictDirective,
    NumberFormatDirective,
    TrimInputDirective,
    SelectDefaultsDirective,
    NumbersOnly
  ]
})
export class SharedModule { }
